import { Button, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material"
import AttachMoneyOutlinedIcon from '@mui/icons-material/AttachMoneyOutlined';
import DisplayEmptyListAction from "../../../../../../components/DisplayEmptyListAction";
import { useMemo, useState } from "react";
import { formatarValorMonetario } from "../../../../../../helpers/masks";
import AddIcon from '@mui/icons-material/Add';
import { IDetalharTituloPagar } from "../../../../../../types/api/financeiro/detalhar-titulo-pagar";
import tratativaDeDatas from "../../../../../../helpers/tratativaDeDatas";
import DialogRegistrarPagamento from "../../DialogRegistrarPagamento";

export default function ValoresPagos({ detalhe, idTitulo }: ValoresPagosProps) {

    const [openPgto, setOpenPgto] = useState(false)

    //funçoes manipuladoras
    const handleOpenRegistrarPgtoDialog = (action: "open" | "close") => {
        if (action === "open") setOpenPgto(true)
        if (action === "close") setOpenPgto(false)
    }
    //

    //valores importantes
    const paddingStyle = { paddingLeft: 0, paddingRight: 0 }

    const valorTitulo = useMemo(() => {
        let valorTituloArray: Array<{id: string}> = [];
        valorTituloArray.push({ id: detalhe.id_titulo });
        return valorTituloArray;
    }, [detalhe]);

    const desabilitarPgto = detalhe.saldo_titulo === 0

    const movPagamento = useMemo(() => {
        return detalhe.movimentacoes
    }, [detalhe])

    const totalMovPgto = useMemo(() => {
        return detalhe.movimentacoes
            .reduce((soma, item) => soma + item.valor_movimento, 0);
    }, [detalhe])
    //

    const Actions = () => (
        <Stack direction="row" gap={2}>
            <Button
                onClick={() => handleOpenRegistrarPgtoDialog("open")}
                variant="outlined"
                size="small"
                startIcon={<AttachMoneyOutlinedIcon />}
            >
                Registrar Pagamento
            </Button>
        </Stack>
    )

    return (
        <>
            {
                movPagamento.length === 0 &&
                <DisplayEmptyListAction
                    label="Nenhum valor pago foi encontrado para esse título. Deseja incluir?"
                    actionSection={<Actions />}
                />
            }

            {
                movPagamento.length > 0 &&
                <TableContainer>
                    <Table size="small" aria-label="a dense table">
                        <TableHead>
                            <TableRow>
                                <TableCell sx={paddingStyle}><b>Data</b></TableCell>
                                <TableCell align="right" sx={paddingStyle}><b>Valor</b></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {movPagamento.map((row, index) => (
                                <TableRow
                                    key={index}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell component="th" scope="row" sx={paddingStyle}>
                                        {tratativaDeDatas(row.data_movimento)}
                                    </TableCell>
                                    <TableCell align="right" sx={paddingStyle}>{formatarValorMonetario(row.valor_movimento)}</TableCell>
                                </TableRow>
                            ))}

                            <TableRow
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell component="th" scope="row" sx={paddingStyle}><b>Total</b></TableCell>
                                <TableCell align="right" sx={paddingStyle}><b>{formatarValorMonetario(totalMovPgto)}</b></TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>

                    <Stack direction="row" justifyContent="flex-end" mt={2}>
                        <Button
                            variant="outlined"
                            size="small"
                            disabled={desabilitarPgto}
                            startIcon={<AddIcon />}
                            onClick={() => handleOpenRegistrarPgtoDialog("open")}
                        >
                            Adicionar
                        </Button>
                    </Stack>
                </TableContainer>
            }

            {
                openPgto &&
                <DialogRegistrarPagamento
                    open={openPgto}
                    handleClose={() => handleOpenRegistrarPgtoDialog("close")}
                    valoresTitulos={valorTitulo}
                />
            }
        </>
    )
}

interface ValoresPagosProps {
    detalhe: IDetalharTituloPagar;
    idTitulo: string;
}
